import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=16b2c2ce&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=16b2c2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2c2ce",
  null
  
)

export default component.exports